import FormControl from "../base/FormControl";

export default class InputEmail extends FormControl {

    constructor(props) {
        super(props);
        this.state.type = "email";
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    render() {
        return super.render();
    }
}